import ClassMode from 'enums/ClassMode';
import { takeLatest } from 'redux-saga/effects';
import { call, put } from 'store/utils';
import * as userActions from 'store/user/userActions';
import { createUser, getUser } from 'utils/apiCalls';
import * as moodleActions from './moodleActions';
import { checkClassSaga } from './moodleSagas';

function* initMoodleUserFlowSaga(action) {
  yield put(moodleActions.initAction({ key: 'initMoodleUser' }));
  try {
    const { urlParams, push } = action.payload;
    const [firstName, lastName] = urlParams.get('name').split(' ');
    const isInstructor = urlParams.get('isInstructor') === '1';
    const meetingId = urlParams.get('meetingId');
    const courseId = urlParams.get('courseId');
    const meetingName = urlParams.get('courseName');
    const email = urlParams.get('email');
    const externalMeetingId = `${courseId}${meetingId}`;
    const type = isInstructor ? ClassMode.Teacher : ClassMode.Student;
    const moodle = true;
    const admin = false;
    const password = null;
    let user = yield call(getUser, null, email);
    if (!user) {
      if (!email) throw Error('User Email Is Required');
      user = yield call(createUser(firstName, lastName, type, moodle, admin, email, password));
    }
    yield put(
      userActions.setUserAction({
        firstName: user.FirstName,
        lastName: user.LastName,
        email: user.Email,
        moodle: user.MoodleUser,
        classMode: user.Type,
        userId: user.UserId,
        admin: user.Admin,
      })
    );
    yield call(checkClassSaga, push, meetingName, externalMeetingId);

    yield put(moodleActions.successAction({ key: 'initMoodleUser' }));
  } catch (error) {
    yield put(moodleActions.errorAction({ key: 'initMoodleUser', error }));
  }
}

function* checkClassFlowSaga(action) {
  yield put(moodleActions.initAction({ key: 'checkClassFlow' }));
  try {
    const { urlParams, push } = action.payload;
    const meetingName = urlParams.get('courseName');
    const meetingId = urlParams.get('meetingId');
    const courseId = urlParams.get('courseId');
    const externalMeetingId = `${courseId}${meetingId}`;

    yield call(checkClassSaga, push, meetingName, externalMeetingId);

    yield put(moodleActions.successAction({ key: 'checkClassFlow' }));
  } catch (error) {
    yield put(moodleActions.errorAction({ key: 'checkClassFlow', error }));
  }
}

export default function* moodleWatcher() {
  yield takeLatest(moodleActions.initMoodleUserAction().type, initMoodleUserFlowSaga);
  yield takeLatest(moodleActions.checkClassFlowAction().type, checkClassFlowSaga);
}
